(() => {
  'use strict';

  if (window.WUBDeliveryRuntimeLoader?.version === 1) return;

  const script = document.currentScript;
  const pending = new Map();

  function sibling(filename) {
    if (!script?.src) return '';
    const url = new URL(script.src, window.location.href);
    url.pathname = url.pathname.replace(/[^/]+$/, filename);
    url.search = '';
    url.hash = '';
    return url.href;
  }

  const sources = Object.freeze({
    engine: sibling('wub-delivery-engine-runtime.js'),
    shipping: sibling('wub-shipping-resolver-runtime.js'),
    promise: sibling('wub-promise-runtime.js'),
    cart: sibling('wub-cart-drawer-delivery-runtime.js')
  });

  function alreadyPresent(src) {
    if (!src) return true;
    return Array.from(document.scripts).some((node) => node.src === src || node.dataset.wubRuntimeSrc === src);
  }

  function loadScript(src) {
    if (!src) return Promise.resolve(true);
    if (pending.has(src)) return pending.get(src);
    if (alreadyPresent(src)) return Promise.resolve(true);

    const promise = new Promise((resolve) => {
      const node = document.createElement('script');
      node.src = src;
      node.defer = true;
      node.dataset.wubRuntimeSrc = src;
      node.addEventListener('load', () => resolve(true), { once: true });
      node.addEventListener('error', () => {
        pending.delete(src);
        resolve(false);
      }, { once: true });
      document.head.appendChild(node);
    });

    pending.set(src, promise);
    return promise;
  }

  async function loadCore() {
    await loadScript(sources.engine);
    await loadScript(sources.shipping);
    await loadScript(sources.promise);
    return true;
  }

  async function loadCart() {
    await loadCore();
    await loadScript(sources.cart);
    return true;
  }

  const pathIsCart = /\/cart\/?$/.test(window.location.pathname);
  const isProduct = Boolean(window.WUB?.settings?.product_id) || document.body?.classList.contains('template-product');

  if (pathIsCart) loadCart();
  else if (isProduct) loadCore();

  ['cart:updated', 'cart:open', 'wub:cart-drawer-opened'].forEach((name) => {
    document.addEventListener(name, () => { loadCart(); }, { passive: true });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('[data-wub-cart-open], [data-wub-cart-drawer], #WubCartDrawer')) return;
    loadCart();
  }, { capture: true, passive: true });

  window.WUBDeliveryRuntimeLoader = Object.freeze({ version: 1, loadCore, loadCart });
})();
